export interface Verticals {
  [key: string]: string;
}

export interface Config {
  sectionUrl?: string;
  verticals?: Verticals;
}

let config: Config = {};

export const setConfig = (newConfig: Config = {}) => {
  config = newConfig;
};

export const getConfig = () => config;
